import { useStore } from 'features/ListBuilder/infra/react/ListBuilderStore/useStore'

export const useDeleteListsState = () =>
  useStore(store => store.deleteLists.state)
